import { useMutation, useQueryClient } from "@tanstack/react-query";
import { parseListResponse, parseResponse } from "lib/fetch";
import type { NotificationInterface } from "types/notification";
import {
    batchReadNotificationsRequest,
    deleteNotificationRequest,
    getNotificationsRequest,
} from "lib/api/notification";

export const fetchNotifications = (params?: HashMap<unknown>) =>
    parseListResponse<NotificationInterface>(getNotificationsRequest(params));

export const batchReadNotifications = (data?: unknown) =>
    parseResponse<NotificationInterface>(batchReadNotificationsRequest(data));

export const deleteNotification = (id: string) =>
    parseResponse<NotificationInterface>(deleteNotificationRequest(id));

export const notificationKeys = {
    all: ["notification"] as const,
    lists: () => [...notificationKeys.all, "list"] as const,
};

export const useBatchReadNotifications = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data?: unknown) => batchReadNotifications(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: notificationKeys.lists() });
        },
    });
};

export const useDeleteNotification = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => deleteNotification(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: notificationKeys.lists() });
        },
    });
};
